// extracted by mini-css-extract-plugin
export default {"container":"Tables_container__t0MV4","toggle":"Tables_toggle__9eq9U","tables":"Tables_tables__RL+fg","containerWidth":"Tables_containerWidth__r8DlP"};